import { render, staticRenderFns } from "./ComplieNewGuideDetails.vue?vue&type=template&id=2656fd52&scoped=true"
import script from "./ComplieNewGuideDetails.vue?vue&type=script&lang=js"
export * from "./ComplieNewGuideDetails.vue?vue&type=script&lang=js"
import style0 from "./ComplieNewGuideDetails.vue?vue&type=style&index=0&id=2656fd52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2656fd52",
  null
  
)

export default component.exports